import React from "react";
import { Box, Typography, Card, CardContent, Grid, useTheme } from "@mui/material";

const StrategyPerformanceMetrics = ({ metricData }) => {
  const theme = useTheme();

  // Helper function to extract numeric value from string (handles percentages and regular numbers)
  const getNumericValue = (valueStr) => {
    if (!valueStr || valueStr === "—" || valueStr === "0") return 0;
    // Remove % sign and convert to number
    const cleaned = valueStr.replace("%", "").trim();
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  };

  // Helper function to get color based on value (green for positive, red for negative)
  const getValueColor = (valueStr) => {
    const numValue = getNumericValue(valueStr);
    if (numValue > 0) return theme.palette.success.main; // Green
    if (numValue < 0) return theme.palette.error.main; // Red
    return theme.palette.text.primary; // Default for zero
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              height: "100%",
            }}
          >
            <CardContent sx={{ minHeight: "120px", display: "flex", flexDirection: "column" }}>
              <Typography
                variant="body2"
                color="textSecondary"
                gutterBottom
              >
                BACKTEST
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mt: 1,
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: theme.palette.text.primary,
                }}
              >
                {metricData.backtestPeriod}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ mt: 1 }}
              >
                {metricData.days}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              height: "100%",
            }}
          >
            <CardContent sx={{ minHeight: "120px", display: "flex", flexDirection: "column" }}>
              <Typography
                variant="body2"
                color="textSecondary"
                gutterBottom
              >
                TOTAL RETURN
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mt: 1,
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: getValueColor(metricData.totalReturn),
                }}
              >
                {metricData.totalReturn}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              height: "100%",
            }}
          >
            <CardContent sx={{ minHeight: "120px", display: "flex", flexDirection: "column" }}>
              <Typography
                variant="body2"
                color="textSecondary"
                gutterBottom
              >
                SHARPE RATIO
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mt: 1,
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: getValueColor(metricData.sharpeRatio),
                }}
              >
                {metricData.sharpeRatio}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ mt: 1 }}
              >
                Risk-adjusted return
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              height: "100%",
            }}
          >
            <CardContent sx={{ minHeight: "120px", display: "flex", flexDirection: "column" }}>
              <Typography
                variant="body2"
                color="textSecondary"
                gutterBottom
              >
                MAX DRAWDOWN
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mt: 1,
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: getValueColor(metricData.maxDrawdown),
                }}
              >
                {metricData.maxDrawdown}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ mt: 1 }}
              >
                {metricData.drawdownDuration}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StrategyPerformanceMetrics;

